import styles from "./ButtonBadge.module.scss";

import { Badge } from "@/dls/Badge";

import { cn } from "@/utils/cn";

type BaseProps = React.ComponentProps<typeof Badge>;

interface Props extends BaseProps {}

const ButtonBadge: React.FC<Props> = ({ className, ...rest }) => {
  return (
    <div className={styles.container}>
      <Badge className={cn(styles.buttonBadge, className)} {...rest} />
    </div>
  );
};

export { ButtonBadge };
